import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import AutomobilesAttachments from './Automobiles/attachments';
import CompensationAttachments from './Compensation/attachments';
import BalanceSheetAttachments from './BalanceSheet/attachments';
import ProfitandLossStatementAttachments from './ProfitandLossStatement/attachments';
import RentalActivityAttachments from './RentalActivity/attachments';
import MiscellaneousInformationAttachments from './MiscellaneousInformation/attachments';

export interface IAdditionalQuestionsAttachmentsProps {}

export default function AdditionalQuestionsAttachments(
  props: IAdditionalQuestionsAttachmentsProps,
) {
  return (
    <div>
      <DashboardContainerHeader title="Additional Questions" />
      <AutomobilesAttachments />
      <CompensationAttachments />
      <BalanceSheetAttachments />
      <ProfitandLossStatementAttachments />
      <RentalActivityAttachments />
      <MiscellaneousInformationAttachments />
    </div>
  );
}
